"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiInject = multiInject;
const decrementPendingClassMetadataCount_1 = require("../actions/decrementPendingClassMetadataCount");
const buildManagedMetadataFromMaybeClassElementMetadata_1 = require("../calculations/buildManagedMetadataFromMaybeClassElementMetadata");
const ClassElementMetadataKind_1 = require("../models/ClassElementMetadataKind");
const injectBase_1 = require("./injectBase");
function multiInject(serviceIdentifier, options) {
    const updateMetadata = (0, buildManagedMetadataFromMaybeClassElementMetadata_1.buildManagedMetadataFromMaybeClassElementMetadata)(ClassElementMetadataKind_1.ClassElementMetadataKind.multipleInjection, serviceIdentifier, options);
    return (0, injectBase_1.injectBase)(updateMetadata, decrementPendingClassMetadataCount_1.decrementPendingClassMetadataCount);
}
//# sourceMappingURL=multiInject.js.map